export interface ParkedFlight {
    id: number;
    origin: string | null;
    destination: string | null;
    aircraftType: string | null;
    position: {
        lat: number;
        lng: number;
    } | null;
    time: number | null;
    acid: string;
}

export class ParkedUpdater {
    private _items: ParkedFlight[] = [];
    private _version = 0;

    get version(): number {
        return this._version;
    }

    get items(): ParkedFlight[] {
        return this._items;
    }

    getParked() {
        return this._items;
    }

    update(data: { replace: boolean; updated: ParkedFlight[]; deleted?: number[] }) {
        this._version++;

        if (data.replace) {
            this._items = data.updated;
            return;
        }

        if (data.deleted != undefined) {
            this._items = this._items.filter((x) => !data.deleted!.includes(x.id));
        }

        // TODO: this may not be the most efficient way of doing this. Max number of parked flights can be 5,000, need to benchmarks what's the best approach
        for (const item of data.updated) {
            const idx = this._items.findIndex((x) => x.id === item.id);
            if (idx === -1) {
                this._items.push(item);
            } else {
                this._items[idx] = item;
            }
        }
    }

    init(items: ParkedFlight[]) {
        this._version++;
        this._items = items;
    }
}
